import { useMemo } from "react";

import { IFolder, WorkspaceFilterItem, WorkspaceFilters, WorkspaceFiltersFromDB } from "store/types";

const FILTER_TYPES: Record<string, "date" | "single" | "raw" | "uppercase"> = {
  last_updated: "date",
  shared_with: "single",
  file_type: "uppercase"
};

const mergeFilters = (regular: WorkspaceFilters = {}, dataroom: WorkspaceFilters = {}): WorkspaceFilters => {
  const merged: WorkspaceFilters = { ...regular };
  for (const key of Object.keys(dataroom)) {
    const existing = merged[key];
    const incoming = dataroom[key];
    merged[key] = existing ? Array.from(new Set([...existing, ...incoming] as WorkspaceFilterItem[])) : incoming;
  }
  return merged;
};

interface UseWorkspaceFilterParams {
  currentFolder: IFolder | null;
  workspaceFiltersFromDB?: WorkspaceFiltersFromDB;
}

export const useWorkspaceFilter = ({
  currentFolder,
  workspaceFiltersFromDB = {}
}: UseWorkspaceFilterParams) => {
  const isDataroom = currentFolder?.kind === "dataroom";
  const isAggregateView = !currentFolder;

  const filtersList = useMemo(() => {
    const { regular_folder, dataroom_folder } = workspaceFiltersFromDB;

    let base: WorkspaceFilters;
    if (isAggregateView) {
      // all files or recently added files
      base = mergeFilters(regular_folder, dataroom_folder);
    } else if (isDataroom) {
      //filters for cloud mirror folder
      base = { ...dataroom_folder };
    } else {
      //filters for regular folder
      base = { ...regular_folder };
    }

    base.shared_with = ["Yes", "No"];
    return base;
  }, [isDataroom, isAggregateView, workspaceFiltersFromDB]);

  const dataroomOnlyKeys = useMemo(() => {
    const regularKeys = new Set(Object.keys(workspaceFiltersFromDB.regular_folder || {}));
    return Object.keys(workspaceFiltersFromDB.dataroom_folder || {}).filter((key) => !regularKeys.has(key));
  }, [workspaceFiltersFromDB.dataroom_folder, workspaceFiltersFromDB.regular_folder]);

  return { filtersList, dataroomOnlyKeys, isDataroom, isAggregateView, filterTypes: FILTER_TYPES };
};
